import {Col, Row } from 'antd';
import Text from 'antd/lib/typography/Text';
import React from 'react';
import { useTranslation } from 'react-i18next';
import XFilled from '@ant-design/icons/XFilled';


export interface IPriceBucketLabelsProps { }

const PriceBucketLabels: React.FunctionComponent<IPriceBucketLabelsProps> = (props) => {
    void props;
    const { t } = useTranslation();

    const standardPriceLabel = t('priceBucketFeature.standardPriceLabel');
    const highlightedPriceLabel = t('priceBucketFeature.highlightedPriceLabel');

    return (
        <Row>
            <Col style={{ paddingRight: '16px' }}>
                <XFilled className='highlightedPriceColor' style={{ paddingRight: '2px' }} />
                <Text>{highlightedPriceLabel}</Text>
            </Col>
            <Col>
                <XFilled className='standardPriceColor' style={{ paddingRight: '2px' }} />
                <Text>{standardPriceLabel}</Text>
            </Col>
        </Row>
    );
};

export default PriceBucketLabels;
